import { Button, ButtonGroup, Box, Text } from '@chakra-ui/react';
import { ReactElement, useState } from 'react';
import { CalendlyInlineWidget, Modal } from 'shared-components';
import { useDispatch } from 'react-redux';
import { getApplicantOffer } from '@/store/apply/actions';
import { useTranslation } from "react-i18next";

interface BookInterviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  applicantId: string;
  uni: string;
  offerId: string;
  utmKey: string;
  schedulingUrl: string | null;
}

export const BookInterviewModal = ({
  isOpen,
  onClose,
  applicantId,
  uni,
  offerId,
  utmKey,
  schedulingUrl,
}: BookInterviewModalProps): ReactElement => {
    const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [bookingConfirmed, setBookingConfirmed] = useState(false);

  const handleEventScheduled = (): void => {
    setBookingConfirmed(true);
  };

  const handleClose = (): void => {
    if (bookingConfirmed) {
      dispatch(getApplicantOffer(applicantId, uni, offerId));
    }
    setBookingConfirmed(false);
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      onClose={handleClose}
      title={t('common:bookInterview')}
      footer={
        <ButtonGroup spacing={3} size="lg">
          <Button onClick={handleClose}>Close</Button>
        </ButtonGroup>
      }
    >
      {schedulingUrl ? (
        <CalendlyInlineWidget url={schedulingUrl} utmContent={utmKey} onEventScheduled={handleEventScheduled} />
      ) : (
        <Box py={4}>
          <Text>{t('common:theBookingLinkIsNotYetConfigured')}</Text>
        </Box>
      )}
    </Modal>
  );
};
